import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import {ChallengeUser} from "../../models/challenge-user";
import {ChallengeProvider} from "../../providers/challenge/challenge";

/**
 * Generated class for the AppChallengeUserPopupStartPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-app-challenge-user-popup-start',
  templateUrl: 'app-challenge-user-popup-start.html',
})
export class AppChallengeUserPopupStartPage {

  finished: boolean = false;
  inputChallenge: {data: ChallengeUser};
  constructor(public navCtrl: NavController, public navParams: NavParams, private challenge: ChallengeProvider) {
    this.inputChallenge = this.navParams.get('challenge');
  }

  start(tomorrow: boolean = false) {
    let payload = {
      status: 1,
    }
    if(tomorrow) {
      var today = new Date();
      today.setDate(today.getDate() + 1)
      payload['startDate'] = today.toISOString().substr(0,10);
    }
    this.challenge.userChallengeUpdate(this.inputChallenge.data, payload).then(() => {
      this.navCtrl.pop();
    })
  }


  ionViewDidLoad() {
    this.finished = (this.inputChallenge.data._userStatus == 2);
  }

  close() {
    this.navCtrl.pop();
  }
}



// WEBPACK FOOTER //
// ./src/pages/app-challenge-user-popup-start/app-challenge-user-popup-start.ts